import {
  CreateUserRequestDtoProfileEnum,
  UserDto,
  UserDtoProfileEnum,
} from 'lib_api/lib/api/gen';

import { FilterDashboardComptesUtilisateurs } from './Dashboard/DashboardHeader/types';

export const defaultFilterValue = (
  user: UserDto,
): Partial<FilterDashboardComptesUtilisateurs> => {
  const defaultReturnValue = {
    searchCompte: undefined,
    email: undefined,
    firstName: undefined,
    lastName: undefined,
    username: undefined,
    entiteRattachement: undefined,
    userType: undefined,
    gestionnaireLocal: undefined,
  };

  if (user.profile === UserDtoProfileEnum.ADMIN_FONCTIONNEL) {
    return defaultReturnValue;
  }

  return {
    ...defaultReturnValue,
    userType: user.profile,
    entiteRattachement: getIdCorrelationEntiteUser(user),
  };
};

export const getIdCorrelationEntiteUser = (
  user: UserDto,
): undefined | string => {
  switch (user.profile) {
    case UserDtoProfileEnum.AUTORITE_FOURRIERE:
      return user.idCorrelationAutoriteFourriere || undefined;
    case UserDtoProfileEnum.FORCE_DE_L_ORDRE:
      return user.idCorrelationUniteFO || undefined;
    case UserDtoProfileEnum.GARDIEN_FOURRIERE:
      return user.idCorrelationFourriere || undefined;
    default:
      return undefined;
  }
};

export const createProfilesWithUniteRattachement =
  new Set<CreateUserRequestDtoProfileEnum>([
    CreateUserRequestDtoProfileEnum.GARDIEN_FOURRIERE,
    CreateUserRequestDtoProfileEnum.AUTORITE_FOURRIERE,
    CreateUserRequestDtoProfileEnum.FORCE_DE_L_ORDRE,
  ]);

export const profilesWithUniteRattachement = new Set<UserDtoProfileEnum>([
  UserDtoProfileEnum.GARDIEN_FOURRIERE,
  UserDtoProfileEnum.AUTORITE_FOURRIERE,
  UserDtoProfileEnum.FORCE_DE_L_ORDRE,
]);

export const eligibleProfileForGestionnaireLocal: Set<CreateUserRequestDtoProfileEnum> =
  new Set<CreateUserRequestDtoProfileEnum>([
    CreateUserRequestDtoProfileEnum.AUTORITE_FOURRIERE,
    CreateUserRequestDtoProfileEnum.FORCE_DE_L_ORDRE,
    CreateUserRequestDtoProfileEnum.GARDIEN_FOURRIERE,
  ]);
